import React from 'react'
import { NavBar } from 'antd-mobile-v5'
import { FillinOutline, UnorderedListOutline } from 'antd-mobile-icons'

const Header = ({ code, text, rightContent, type }) => (
  <NavBar
    style={{ background: 'var(--adm-color-primary)', marginBottom: '10px', color: '#ffffff' }}
    right={rightContent}
    left={type === 'list' ? <UnorderedListOutline fontSize={20} /> : <FillinOutline fontSize={20} />}
    back={null}
  >
    <span>
      {text}
      &nbsp;{code && <span>({code})</span>}
    </span>
  </NavBar>
)

export default Header
